var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJ02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.8,28.8h63.8C87.8,28.8,100,41,100,56.1v15.6H36.2c-15.1,0-27.4-12.2-27.4-27.4L8.8,28.8z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.7,
    y1: 28.3,
    x2: 2.7,
    y2: 46.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 28.3,
    x2: 5.5,
    y2: 28.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 46.6,
    x2: 5.5,
    y2: 46.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ02);
export default __webpack_public_path__ + "static/media/j_02.db1117000d53d53c28fb3f6882805be4.svg";
export { ForwardRef as ReactComponent };